module.exports = __webpack_public_path__ + "fcf509b836dc1238b8f898ea673eb723.pdf";